export const appHeaderElementSelectors: { name: { [key: string]: string } } = {
  name: {
    downloadBtn: 'main-header-menu--download-btn',
    paymentMethodsInfo: 'paymentMethodsInfo',
    paymentMethodsInfoDivider: 'paymentMethodsInfoDivider',
    paymentMethodsInfoSubtitle: 'paymentMethodsInfoSubtitle'
  }
};

export const enableNewRmmPage = false;
